import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import '../stylesheets/errorPage.css';

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);

        this.state = {
            hasError: false
        };
        this.goBack = this.goBack.bind(this);
    }

    static getDerivedStateFromError() {
        return {
            hasError: true
        };
    }

    componentDidCatch(error, info) {
        console.log(error);
        console.log(info);
    }

    goBack() {
        window.history.back();
    }


    render() {
        if (this.state.hasError) {
            return (
                <div className="mainbox">
                    <div className="err">
                        Oops...
                    </div>
                    <div className="msg">
                        Maybe something got broken
                        <p>Let's go&nbsp;
                            <Button onClick={this.props.logout} variant="primary" size="md">Home</Button>
                            &nbsp;and try from there.
                        </p>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}
export default ErrorBoundary;